<template>
  <div class="send-customisation-enquiry-component p-3">
    <h5>Want to discuss?</h5>
    <p>Submit your configuration and we’ll contact you to discuss your next steps.</p>
    <button @click="enquire()" type="button" class="btn btn-secondary d-flex w-100 justify-content-between align-items-center" :disabled="loading || sent">
      {{ btnText }} <i class="far fa-paper-plane"></i>
    </button>
    <p class="mt-2" v-if="sentOn">You sent an enquiry about this on {{ sentOn }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      sent: false,
      btnText: 'Send as enquiry',
      sentOn: null,
    };
  },

  props: {
    preloadName: {
      type: String,
      default: null,
    },
    preloadId: {
      type: Number,
      default: null,
    }
  },

  watch: {
    //
  },

  created() {
    this.getEnquiries();
  },

  methods: {
    
    // Check if there already are existing enquiries for the customisation id
    getEnquiries() {
      this.loading = true;

      if(this.preloadId != null) {
        axios.get(window.api_url + '/customiser/enquiries/?customisation=' + this.preloadId)
        .then(res => {
          if(res.data.enquiry) {
            const date = new Date(res.data.enquiry.created_at);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = String(date.getFullYear()).slice(-2);

            this.sentOn = `${day}/${month}/${year}`;
            this.btnText = "Sent";
            this.sent = true;
          }
        }).catch(err => {
          notyf.error("Something went wrong, please try again later.");
        }).finally(() => {
          this.loading = false;
        });
      }
    },

    enquire() {

      this.loading = true;
      
      // fire an event for redeye tracking
      const event = new Event('customisation-sent-event');
      dispatchEvent(event);

      axios.post(window.api_url + '/customiser/enquire', {
        name: this.preloadName
      })
        .then(res => {
          if (res.data.success) {
            notyf.success("Your customisation has been sent to our support team, they will be in touch soon.");
            this.btnText = 'Sent';
            this.sent = true;
          }
        })
        .catch(err => {
          notyf.error("Something went wrong, please try again later.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
